import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW1108Component } from './kymw1108.component';
import { GetEbaseCandidateListService } from './api-service/get-ebase-candidate-list.service';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FontAwesomeModule,
    WjNavModule,
    WjGridModule,
    AppCommonsModule,
    PlessSharedModule
  ],
  declarations: [
    KYMW1108Component
  ],
  providers: [
    GetEbaseCandidateListService
  ],
})
export class Kymw1108Module { }
